<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.17071 4H19C19.5523 4 20 4.44772 20 5V17.8293C21.1652 17.4175 22 16.3062 22 15V5C22 3.34315 20.6569 2 19 2H9C7.69378 2 6.58254 2.83481 6.17071 4Z"
      fill="#0F2D5A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 9C2 7.34315 3.34315 6 5 6H15C16.6569 6 18 7.34315 18 9V19C18 20.6569 16.6569 22 15 22H5C3.34315 22 2 20.6569 2 19V9ZM5 8H15C15.5523 8 16 8.44772 16 9V19C16 19.5523 15.5523 20 15 20H5C4.44772 20 4 19.5523 4 19V9C4 8.44772 4.44772 8 5 8Z"
      fill="#0F2D5A"
    />
  </svg>
</template>
